import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'


class Roll extends Component {

    constructor(element) {


        super(element);
        this.element = element
        this.el = $(element)

        this.ref = {
            track: null,
            elm: null
        }

        this.speed = 1.2

    }

    mount() {
        

        this.currentX = 0
        this.resizeQue = this.resize.bind(this)
        this.renderQue = this.render.bind(this)
        stage.on("stage:scroll", this.renderQue);
        stage.on("stage:resize", this.resizeQue);
        this.resize(stage);

    }


    stop() {
        this.isPlaying && renderer.remove(this)
        this.isPlaying = false
        //console.log('stop');
    }

    play() {
        !this.isPlaying && renderer.add(this)
        this.isPlaying = true
        //console.log('play');
    }


    resize(e) {
        //  console.log('do resize');
        this.w = this.ref.elm.offsetWidth
        const box = this.element.getBoundingClientRect()
       // console.log(box);

        this.top = box.top
        this.render(e)

    }

    render(e) {
      //  console.log(stage.scrolltop + stage.h, this.top);

      //console.log(this.top, stage.scrolltop + stage.h);

        if (this.top <= stage.scrolltop + stage.h)(
            this.play()
        )
        else(
            this.stop()
        )
    }



    renderQueCall() {
        //console.log('go');
        this.w = this.ref.elm.offsetWidth

        this.currentX -= this.speed
        if (this.currentX < -this.w) {
            this.currentX = 0
        }

        gsap.set(this.ref.track, {
            x: this.currentX,
            force3D: true
        })

    }

    unmount() {
        this.stop()
        stage.removeListener("stage:resize", this.resizeQue);
        stage.removeListener("stage:scroll", this.renderQue);
        //console.log("Unmount Text!");
    }


}

module.exports = Roll
